export default __webpack_public_path__ + "static/763-138d639190b0246200bb89512169aec0.gif";